function decodeBase64Url(base64Url) {
  const padding = '=='.slice(0, (4 - base64Url.length % 4) % 4);
  const base64 = (base64Url + padding).replace(/-/g, '+').replace(/_/g, '/');

  if (typeof window !== 'undefined' && typeof window.atob === 'function') {
    return window.atob(base64);
  }

  return Buffer.from(base64, 'base64').toString('utf8');
}

export function decodeTokenPayload(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }

  try {
    const tokenParts = token.split('.');
    if (tokenParts.length < 2 || !tokenParts[1]) {
      return null;
    }

    return JSON.parse(decodeBase64Url(tokenParts[1]));
  } catch (error) {
    console.error('Erro ao decodificar o token:', error);
    return null;
  }
}

export function resolveUserIdFromToken(token, fallbackUserId) {
  const payload = decodeTokenPayload(token);
  const sub = payload && payload.sub;

  if (sub != null && sub !== '') {
    const parsed = parseInt(sub, 10);
    return Number.isNaN(parsed) ? sub : parsed;
  }

  if (fallbackUserId != null && fallbackUserId !== '') {
    return fallbackUserId;
  }

  return null;
}
